import { render, staticRenderFns } from "./block-access-control-badge-modal.vue?vue&type=template&id=75039730&"
import script from "./block-access-control-badge-modal.vue?vue&type=script&lang=ts&"
export * from "./block-access-control-badge-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports